import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import SitePageTemplate from '../components/SitePageTemplate'
import  { HTMLContent } from '../components/body/content'

const Component = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <Layout>
      <SitePageTemplate
        heroClass='is-hidden-touch'
        content={post.html}
        contentComponent={HTMLContent}
        helmet={<Helmet title={`EmeraldField High School Calabar | ${post.frontmatter.title}`} />}
        title={post.frontmatter.title}
        image={post.frontmatter.image}
      />
    </Layout>
  )
}

Component.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default Component

export const pageQuery = graphql`
  query SitePageByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
        image{
          src
          alt
          externalSrc
        }
        name
      }
    }
  }
`
